import { type SelectOption } from '@shared/utils/types/select-option';

export const getTimezoneOptions = (): SelectOption[] => {
  const now = new Date();

  return Intl.supportedValuesOf('timeZone')
    .map((tz) => {
      const currentOffset =
        new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'shortOffset' })
          .formatToParts(now)
          .find((p) => p.type === 'timeZoneName')?.value ?? 'GMT';

      const utc = currentOffset
        .replace('GMT', 'UTC')
        .replace(
          /UTC([+-])(\d{1,2})(?::(\d{2}))?$/u,
          // eslint-disable-next-line @typescript-eslint/no-shadow
          (_, sign, hour, minute = '00') => `UTC${sign}${hour.padStart(2, '0')}:${minute}`
        )
        .replace(/^UTC$/u, 'UTC+00:00');
      const city = tz.split('/').at(-1)?.replaceAll('_', ' ') ?? tz;

      const [, sign = '+', hour = '0', minute = '0'] = utc.match(/UTC([+-])(\d{2}):(\d{2})/u) ?? [];
      const offsetMinutes = (sign === '+' ? 1 : -1) * (Number(hour) * 60 + Number(minute));

      return { label: `(${utc}) ${city}`, offsetMinutes, value: tz };
    })
    .sort((first, second) => first.offsetMinutes - second.offsetMinutes)
    .map(({ label, value }) => ({ label, value }));
};
